import { render, staticRenderFns } from "./BalanceIndicator.vue?vue&type=template&id=282c6884"
import script from "./BalanceIndicator.vue?vue&type=script&lang=js"
export * from "./BalanceIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports